import type { FaireProductEntity } from "../../entity_types/product";

export const p_sa4p8577nw: FaireProductEntity = {
  token: "p_sa4p8577nw",
  type: "product",
  name: "I Love You Dad Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/ae67987ce6cdc9673f4747cf433be5b0e9fd6636aca70f278f4f06571b4bb969.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2debeb22b1f815df5e9a37d9e4f11db28ef32f50bc097916c42cda44d93321d4.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:44.190Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
